import { render, staticRenderFns } from "./ParcelamentoRelpView.vue?vue&type=template&id=395b40de&"
import script from "./ParcelamentoRelpView.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoRelpView.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoRelpView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports